import { forwardRef, type AnchorHTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface InlineLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode;
}

export const InlineLink = forwardRef<HTMLAnchorElement, InlineLinkProps>(
  ({ children, className, ...props }, ref) => (
    <a
      ref={ref}
      className={cn(
        'text-ds-accent underline underline-offset-2 cursor-pointer',
        className
      )}
      {...props}
    >
      {children}
    </a>
  )
);

InlineLink.displayName = 'InlineLink';
